import React from "react";
import ProgressiveImage from "react-progressive-image";
import { useLocation } from "react-router-dom";
import { WEBSITE_BASE_URL } from "../../../../api";
import Ink from "react-ink";
import BackButtonWithName from "../../../Elements/BackButtonWithName";
import placeHolderImg  from "../../../../assets/img/placeholder.jpeg"
const AllPopularItems = () => {
  const location = useLocation();
  const items = location.state?.items || [];

  return (
    <div style={{ padding: "16px" }}>
      <BackButtonWithName title={localStorage.getItem("all_categories")} />
      <div
        className="mt-5"
        style={{ display: "flex", flexDirection: "column", gap: "16px" }}
      >
        {items.map((item, index) => (
          <div
            key={index}
            style={{
              padding: "16px",
              border: "1px solid #ddd",
              borderRadius: "8px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
              display: "flex",
              flexDirection: "row",
              gap: "16px",
              alignItems: "center",
                position: "relative",
            }}
          >
            <div className="position-relative">
              <div
                className=""
                style={{
                  borderRadius: "cd8px",
                  mixBlendMode: "darken",
                  opacity: "0.9",
                }}
              >
                <ProgressiveImage
                  delay={20}
                  src={WEBSITE_BASE_URL + item.image1}
                  placeholder={placeHolderImg }
                >
                  {(src) => (
                    <img
                      src={src}
                      alt={item.name}
                      style={{
                        width: "160px",
                        height: "112px",
                        borderTopLeftRadius: "20px",
                        borderTopRightRadius: "20px",
                        objectFit: "cover",
                      }}
                    />
                  )}
                </ProgressiveImage>
              </div>
              <Ink style={{ color: "#aaaaaa" }} />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              <div style={{ fontWeight: "600", fontSize: "16px" }}>
                {item.name}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "12px",
                }}
              >
                <div
                  style={{
                    display: "flex-col",
                  }}
                >
                  <div
                    style={{
                      fontWeight: 400,
                      fontSize: "14px",
                      color: "#722DD2",
                    }}
                  >
                    {localStorage.getItem("sr")}
                  </div>
                  <div
                    style={{
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "#722DD2",
                    }}
                  >
                    {item.selling_price}
                  </div>
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#aaa",
                    backgroundColor: "#F1F5F9",
                    padding: "2px 8px",
                    borderRadius: "10px",
                  }}
                >
                  <div className="text-[#37474F80] px-2">
                    {" "}
                    {localStorage.getItem("sr")} {item.market_price}
                  </div>
                </div>
              </div>
               <div
                  style={{
                    backgroundColor: "#722DD2",
                    color: "#ffffff",
                    borderRadius: "9999px",
                    textAlign: "center",
                    padding: "8px 0",
                    fontSize: "12px",
                    fontWeight: 500,
                    position: "absolute",
                    bottom: "-12px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "45%",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    zIndex: 10,
                  }}
                >
                  {localStorage.getItem("customizable") || "Customizable"}
                </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllPopularItems;
